import { useState } from "react";
import { UnifiedLandscapeTable } from "@/components/keyword-landscape-output/UnifiedLandscapeTable";
import { cn } from "@/lib/utils";
import { LandscapeTab, type LandscapeOutputData } from "@/types";

const TABS = [
  { value: LandscapeTab.Keyword, label: "Keyword Analysis" },
  { value: LandscapeTab.Competitor, label: "Competitor Analysis" },
];

interface PublicLandscapeViewProps {
  payload: LandscapeOutputData;
}

export function PublicLandscapeView({ payload }: PublicLandscapeViewProps) {
  const [activeTab, setActiveTab] = useState<LandscapeTab>(LandscapeTab.Keyword);

  return (
    <div className="space-y-4 flex flex-col flex-1">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 bg-muted/50 p-1 rounded-[8px]">
          {TABS.map((tab) => {
            return (
              <button
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={cn(
                  "px-3.5 py-1.5 text-sm font-medium rounded-[8px] transition-all",
                  activeTab === tab.value
                    ? "bg-primary text-primary-foreground shadow-sm"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted",
                )}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="flex items-center border border-border rounded-[3px] divide-x divide-border">
          <div className="px-4 py-2 text-center">
            <p className="text-[10px] text-muted-foreground font-medium">Relevant Keywords</p>
            <p className="text-sm font-semibold text-foreground">{payload.totals.relevantKeywords.toLocaleString()}</p>
          </div>
          <div className="px-4 py-2 text-center">
            <p className="text-[10px] text-muted-foreground font-medium">Exact Volume</p>
            <p className="text-sm font-semibold text-foreground">{payload.totals.exactVolume.toLocaleString()}</p>
          </div>
          <div className="px-4 py-2 text-center">
            <p className="text-[10px] text-muted-foreground font-medium">Monthly Units</p>
            <p className="text-sm font-semibold text-foreground">{payload.totals.monthlyUnits.toLocaleString()}</p>
          </div>
        </div>
      </div>

      <UnifiedLandscapeTable data={payload} isPublic activeTab={activeTab} />
    </div>
  );
}
